import { render } from "./AddOption.vue?vue&type=template&id=5a76bdbf&ts=true"
import script from "./AddOption.vue?vue&type=script&lang=ts"
export * from "./AddOption.vue?vue&type=script&lang=ts"

import "./AddOption.vue?vue&type=style&index=0&id=5a76bdbf&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__